import { createStore, initReducers } from './base';
import modules from './modules';
import { ApplicationInstances, ReduxStoreOptions } from './interfaces/sdkInterface';
import { GlobalSpinner } from 'sdk/connector/globalSpinner';
import { Store } from '@reduxjs/toolkit';

let instance: ApplicationInstances;
let reduxStore: Store;

export const getStore = () => {
    return reduxStore;
};
const createInstance = (options?: ReduxStoreOptions) => {
    const reducerMap: Record<string, Function> = {};
    const instances: any = {};
    Object.keys(modules).forEach((key1) => {
        const obj = (modules as any)[key1];
        instances[key1] = obj.class;
        reducerMap[key1] = obj.reducer;
    });
    reduxStore = options?.store || getStore() || createStore({}, reducerMap);
    initReducers(reducerMap);
    if (!instance) {
        Object.keys(instances).forEach((key) => {
            instances[key] = new instances[key](reduxStore);
        });
        instance = { ...instances };
    }
    return instance;
};

const initGlobals = () => {
    GlobalSpinner.getInstance().init(instance);
};

export const sdkInstance = () => instance;
export const getInstance = (options?: ReduxStoreOptions) => {
    if (!instance) {
        instance = createInstance(options);
    }
    initGlobals();
    return instance;
};
